import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import './ScrollProgressBar.css';

const ScrollProgressBar = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 200, damping: 30, mass: 0.2 });

  return <motion.div className="scroll-progress-bar" style={{ scaleX }} />;
};

export default ScrollProgressBar;
